var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "3.06 1.667 25.885 28.667"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#B8EEFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m12.527 25.828.78 1.753a2.95 2.95 0 0 0 5.392 0l.779-1.753a3.23 3.23 0 0 1 3.293-1.898l1.907.203a2.95 2.95 0 0 0 2.696-4.67l-1.129-1.55A3.24 3.24 0 0 1 25.632 16c0-.684.217-1.351.62-1.905l1.128-1.551a2.948 2.948 0 0 0-1.047-4.365 2.95 2.95 0 0 0-1.65-.305l-1.906.203a3.24 3.24 0 0 1-1.96-.416 3.23 3.23 0 0 1-1.333-1.49l-.785-1.752a2.95 2.95 0 0 0-5.393 0l-.78 1.753a3.24 3.24 0 0 1-1.332 1.489 3.25 3.25 0 0 1-1.96.416L7.32 7.874a2.95 2.95 0 0 0-2.696 4.67l1.129 1.55a3.24 3.24 0 0 1 0 3.811l-1.13 1.551a2.948 2.948 0 0 0 1.048 4.365 2.95 2.95 0 0 0 1.649.305l1.907-.203a3.234 3.234 0 0 1 3.3 1.905"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B8EEFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16 20a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
  })));
};
export default SvgSettings;